/** 次のページ遷移方向 */
export enum NavigationDirection {
  /** 次ページ */
  NEXT = 'next',
  /** 前ページ */
  PREVIOUS = 'previous',
  /** そのまま */
  STAY = 'stay'
}
